<div class="social">
	<h3 *ngIf="heading" [innerHTML]="heading"></h3>
	<p *ngIf="subheading" [innerHTML]="subheading"></p>
	<ul *ngIf="getLinks().length" class="social-links">
		<li *ngFor="let link of getLinks()">
			<a [href]="link.url" target="_blank" (click)="analyticsService.trackInput($event);">
				<img [class]="link.id" [src]="link.image" width="70" [alt]="'Social Link - ' + link.name">
			</a>
		</li>
	</ul>
</div>
